export const REQUEST_PASSWORD_EMAIL = "REQUEST_PASSWORD_EMAIL"
export const REQUEST_PASSWORD_EMAIL_SUCCESS = "REQUEST_PASSWORD_EMAIL_SUCCESS"
export const REQUEST_PASSWORD_EMAIL_FAILED = "REQUEST_PASSWORD_EMAIL_FAILED"

export const RESET_PASSWORD_EMAIL = "RESET_PASSWORD_EMAIL"
export const RESET_PASSWORD_EMAIL_SUCCESS = "RESET_PASSWORD_EMAIL_SUCCESS"
export const RESET_PASSWORD_EMAIL_FAILED = "RESET_PASSWORD_EMAIL_FAILED"